import React from 'react';
import styles from 'src/pages/Design/pages/GameDashboardGlass/GameDashboardGlass.module.scss';
import AssassinsPng from 'src/pages/Design/pages/GameDashboardGlass/assets/assassins.png';
import AvatarPng from 'src/pages/Design/pages/GameDashboardGlass/assets/avatar.png';
import ControllerPng from 'src/pages/Design/pages/GameDashboardGlass/assets/controller.png';
import LibraryPng from 'src/pages/Design/pages/GameDashboardGlass/assets/library.png';
import SackboyPng from 'src/pages/Design/pages/GameDashboardGlass/assets/sackboy.png';
import SpidermanPng from 'src/pages/Design/pages/GameDashboardGlass/assets/spiderman.png';
import SteamPng from 'src/pages/Design/pages/GameDashboardGlass/assets/steam.png';
import TwitchPng from 'src/pages/Design/pages/GameDashboardGlass/assets/twitch.png';
import UpcomingPng from 'src/pages/Design/pages/GameDashboardGlass/assets/upcoming.png';

const GameDashboardGlass: React.FC = () => {
  return (
    <div className={styles.container}>
      <main className={styles.main}>
        <section className={styles.glass}>
          <div className={styles.dashboard}>
            <div className={styles.user}>
              <img
                src={AvatarPng}
                alt=''
              />
              <h3 className={styles.header3}> Simo Edwin </h3>
              <p className={styles.paragraph}> Pro Member </p>
            </div>
            <div className={styles.links}>
              <div className={styles.link}>
                <img
                  src={TwitchPng}
                  alt=''
                />
                <h2> Streams </h2>
              </div>
              <div className={styles.link}>
                <img
                  src={SteamPng}
                  alt=''
                />
                <h2> Games </h2>
              </div>
              <div className={styles.link}>
                <img
                  src={UpcomingPng}
                  alt=''
                />
                <h2> New </h2>
              </div>
              <div className={styles.link}>
                <img
                  src={LibraryPng}
                  alt=''
                />
                <h2> Library </h2>
              </div>
            </div>
            <div className={styles.pro}>
              <h2> Join pro for free games. </h2>
              <img
                src={ControllerPng}
                alt=''
              />
            </div>
          </div>
          <div className={styles.games}>
            <div className={styles.status}>
              <h1 className={styles.header1}> Active Games </h1>
              <input type='text' />
            </div>
            <div className={styles.cards}>
              <div className={styles.card}>
                <img
                  src={AssassinsPng}
                  alt=''
                />
                <div className={styles.cardInfo}>
                  <h2 className={styles.header2}> Assassins Creed Valhalla </h2>
                  <p className={styles.paragraph}> PS5 Version </p>
                  <div className={styles.progress}></div>
                </div>
                <h2 className={`${styles.header2} ${styles.percentage}`}>
                  60%
                </h2>
              </div>
              <div className={styles.card}>
                <img
                  src={SackboyPng}
                  alt=''
                />
                <div className={styles.cardInfo}>
                  <h2 className={styles.header2}> Sackboy A Fun Adventure </h2>
                  <p className={styles.paragraph}> PS5 Version </p>
                  <div className={styles.progress}></div>
                </div>
                <h2 className={`${styles.header2} ${styles.percentage}`}>
                  60%
                </h2>
              </div>
              <div className={styles.card}>
                <img
                  src={SpidermanPng}
                  alt=''
                />
                <div className={styles.cardInfo}>
                  <h2 className={styles.header2}> SpiderMan Miles Morales </h2>
                  <p className={styles.paragraph}> PS5 Version </p>
                  <div className={styles.progress}></div>
                </div>
                <h2 className={`${styles.header2} ${styles.percentage}`}>
                  60%
                </h2>
              </div>
            </div>
          </div>
        </section>
      </main>
      <div className={styles.circle1}></div>
      <div className={styles.circle2}></div>
    </div>
  );
};

export default GameDashboardGlass;
